module.exports = __webpack_public_path__ + "img/undraw_remotely_2j6y-3.bad19771.svg";